import { omit } from 'lodash'
import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import Slate from './Slate'

/**
 * @example
 * <RichText
 *   autoFocus
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Text" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   placeholder={<FormattedMessage id="SomePlaceholder" defaultMessage="Some Placeholder" />}
 *   required
 * />
 */
const RichText = ({ onBlur, className, ...props }: any) => {
  const fieldProps = omit(props, ['children'])
  return (
    <Field
      {...fieldProps}
      className={cn('form__richtext', className)}
      render={({ ...field }) => <Slate {...field} onBlur={onBlur} />}
    />
  )
}

RichText.displayName = 'RichText'
RichText.propTypes = {
  ...propTypes,
  autoFocus: PropTypes.bool,
  bulletedListToolbar: PropTypes.bool,
  numberedListToolbar: PropTypes.bool,
  format: PropTypes.string,
  placeholder: PropTypes.node,
  onBlur: PropTypes.func
}
RichText.defaultProps = { ...defaultProps, autoFocus: false, onBlur: () => {} }

export default RichText
